import axios from 'axios';
import { reset as resetForm, initialize } from 'redux-form';
import { BASE_API, USER_TOKEN } from 'config/consts';
import _ from 'lodash';
import types from './types';

const URL = `${BASE_API}/categories`;

export const getList = (id) => {
  return (dispatch) => {
    dispatch({ type: types.LIST_LOAD, payload: true });
    axios
      .get(`${URL}/?where[station_id]=${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch([
          {
            type: types.LIST_FETCHED,
            payload: response,
          },
        ]);
      });
  };
};

/**
 * Carrega as atividades ainda vinculadas à categoria para montar os avisos
 * prévios do fluxo guiado de exclusão.
 */
export const getUsage = (id) => {
  return (dispatch) => {
    dispatch([
      { type: types.USAGE_LOAD, payload: true },
      { type: types.USAGE_FETCHED, payload: null },
    ]);
    axios
      .get(`${URL}/${id}/usage`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        dispatch({ type: types.USAGE_FETCHED, payload: response.data });
      })
      .catch((e) => {
        dispatch([
          { type: types.USAGE_LOAD, payload: false },
          {
            type: 'SNACKBAR',
            payload: {
              message: `Erro ao carregar as atividades da categoria: ${
                e.response?.data?.error || e.message
              }`,
              variant: 'error',
              open: true,
            },
          },
        ]);
      });
  };
};

export const resetUsage = () => {
  return (dispatch) => {
    dispatch({ type: types.USAGE_RESET });
  };
};

/**
 * Soft delete: a categoria continua no banco com `deletedAt` preenchido.
 * `options` carrega a estratégia aplicada às atividades que ficariam sem
 * categoria (`unlink` | `move` | `end` | `deactivate`).
 */
export const remove = (id, stationId, options = {}, onSuccess = undefined) => {
  return (dispatch) => {
    dispatch({ type: types.DELETE_LOAD, payload: true });
    axios
      .delete(`${URL}/${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
        data: {
          strategy: options.strategy || 'unlink',
          target_category_id: options.target_category_id || null,
          reason: options.reason || null,
        },
      })
      .then(() => {
        dispatch([
          {
            type: 'SNACKBAR',
            payload: {
              message: 'Categoria excluída com sucesso',
              variant: 'success',
              open: true,
            },
          },
          { type: types.DELETE_LOAD, payload: false },
          { type: types.USAGE_RESET },
          getList(stationId),
        ]);
        if (_.isFunction(onSuccess)) onSuccess();
      })
      .catch((e) => {
        dispatch([
          { type: types.DELETE_LOAD, payload: false },
          {
            type: 'SNACKBAR',
            payload: {
              message: `Erro: ${e.response?.data?.error || e.response?.data?.message || e.message}`,
              variant: 'error',
              open: true,
            },
          },
        ]);
      });
  };
};

export const getDetail = (id) => {
  return (dispatch) => {
    axios
      .get(`${URL}/${id}`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      })
      .then((response) => {
        const initialValues = {
          ...response.data[0],
        };
        dispatch([
          {
            type: types.ITEM_DETAIL,
            payload: response.data[0],
          },
          initializeForm(initialValues),
        ]);
      });
  };
};

export const setDetail = (values) => {
  return (dispatch) => {
    const initialValues = {
      ...values,
    };
    dispatch([
      {
        type: types.ITEM_DETAIL,
        payload: { data: values },
      },
      initializeForm(initialValues),
    ]);
  };
};

export const initializeForm = (values) => {
  return initialize('categoriesForm', values);
};

export const reset = () => {
  return resetForm('categoriesForm');
};

export const create = (values, router, firstTime) => {
  return submit(values, 'post', router, firstTime);
};

export const update = (values, router) => {
  return submit(values, 'put', router);
};

function submit(values, method, router = undefined, firstTime) {
  const id = values.id ? `${values.id}/` : '';
  return (dispatch) => {
    dispatch([
      { type: types.BUTTON_LOAD, payload: true },
      { type: 'SUBMIT_PROGRESS', payload: 1 },
    ]);
    axios[method](`${URL}/${id}`, values, {
      headers: {
        Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
      },
      onUploadProgress: (progressEvent) =>
        dispatch([
          {
            type: 'SUBMIT_PROGRESS',
            payload: `${Math.round((progressEvent.loaded * 100) / progressEvent.total)} %`,
          },
        ]),
    })
      .then((response) => {
        /* dispatch([reset(), getList()]); */
        dispatch([
          { type: types.BUTTON_LOAD, payload: false },
          {
            type: 'SUBMIT_PROGRESS',
            payload: 0,
          },
          {
            type: 'SNACKBAR',
            payload: {
              message: 'Operação realizada com sucesso',
              variant: 'success',
              open: true,
            },
          },
        ]);

        if (!_.isUndefined(router)) {
          if (firstTime) {
            router.push('/owner');
          } else {
            router.push('/owner/minhas-categorias');
          }
        }
      })
      .catch((e) => {
        dispatch([
          { type: types.BUTTON_LOAD, payload: false },
          {
            type: 'SUBMIT_PROGRESS',
            payload: 0,
          },
        ]);

        try {
          if (e.response.data.error) {
            dispatch({
              type: 'SNACKBAR',
              payload: {
                message: `Erro: ${e.response.data.error}`,
                variant: 'error',
                open: true,
              },
            });
          } else {
            for (const i in e.response.data) {
              for (const j in e.response.data[i]) {
                dispatch({
                  type: 'SNACKBAR',
                  payload: {
                    message: `${i}: ${e.response.data.errors[i][j]}`,
                    variant: 'error',
                    open: true,
                  },
                });
              }
            }
          }
        } catch (error) {
          dispatch({
            type: 'SNACKBAR',
            payload: { message: 'Erro', variant: 'error', open: true },
          });
        }
      });
  };
}

export const setLoading = (bool) => {
  return (dispatch) => {
    dispatch({
      type: types.LIST_LOAD,
      payload: false,
    });
  };
};

export const fileRejected = () => {
  return (dispatch) => {
    dispatch({
      type: 'SNACKBAR',
      payload: {
        message: 'Erro: Imagem maior que 2MB',
        variant: 'error',
        open: true,
      },
    });
  };
};
